import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setLocalStorageItem } from "../../../../src/utils/index";
import { Button, Input, message } from "antd";
import { images } from "../../../assets/images";
import { loginApi } from "./AuthapiFunctions";

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ email: "", password: "" });

  const handlelogin = () => {
    setLoading(true);
    const data = {
      email: userData.email,
      password: userData.password,
    };
    loginApi(data)
      .then((response) => {
        if (response.data.status) {
          setLocalStorageItem("token", response.data?.token);
          setLocalStorageItem("user", response.data?.user);
          setLocalStorageItem("login", true);
          navigate("/dashboard");
          message.success({ content: response.data?.message });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlelogin();
    }
  };
  return (
    <div className="h-screen  bg-rgbaprimary1 flex items-center">
      <div className="w-[800px] relative z-10 max-w-[100%] m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[40%_60%]  shadow-[-5px_0px_15px_#ddd]">
        {/* <div className="absolute -z-10 top-[70%] left-[-15%] -rotate-12 hidden md:block">
          <img
            src={images.bgImg2}
            alt="logo"
            className="w-[80%] mt-3 mb-3 mx-auto  "
          />
        </div>
        <div className="absolute -z-10 bottom-[74%] -right-[36%] -rotate-45 hidden md:block">
          <img
            src={images.bgImg1}
            alt="logo"
            className="w-[38%] mt-3 mb-3 mx-auto"
          />
        </div> */}
        <div className="p-16 rounded-s-md bg-rgbaprimary8">
          <div className="">
            <img
              src={images.icon}
              alt="logo"
              className="w-auto rounded-2xl mt-3 mb-3 mx-auto h-20 flex justify-center  items-center"
            />
          </div>

          <p className=" text-center text-sm  text-white  font-medium">
            With Your Yards Admin Panel, you can focus solely on managing
            effortlessly handle buying and selling of flats, villas, and
            plots—whether residential or commercial—through our streamlined,
            user-friendly platform.
          </p>
        </div>
        <div className="p-20 rounded-e-md bg-white">
          <p className="  text-2xl   block text-rgbaprimary9  font-medium mb-6">
            Account Login
          </p>
          <div className=" my-4">
            <label
              className="block text-rgbaprimary9 text-md font-medium mb-4"
              htmlFor="username"
            >
              Email Address
            </label>
            <Input
              type="email"
              // placeholder="Enter mobile number here..."
              name="email"
              onKeyDown={handleKeyPress}
              required
              className="shadow appearance-none border rounded w-full py-3 px-3 text-rgbaprimary9 text-sm leading-tight focus:outline-none focus:shadow-outline"
              onChange={(e) =>
                setUserData({ ...userData, email: e.target.value })
              }
            />
          </div>
          <div className="">
            <label
              className="block text-rgbaprimary9 text-md font-medium mb-4"
              htmlFor="password"
            >
              Password
            </label>
            <Input.Password
              // placeholder="Enter password here..."
              name="password"
              onKeyDown={handleKeyPress}
              required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-rgbaprimary9 text-sm leading-tight focus:outline-none focus:shadow-outline mb-7"
              onChange={(e) =>
                setUserData({ ...userData, password: e.target.value })
              }
            />
          </div>

          <Button
            loading={loading}
            type="button"
            className="text-white h-10 bg-rgbaprimary8 w-full font-semibold"
            onClick={handlelogin}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Login;
